import { useState } from 'react';
import styled from 'styled-components';
import { useDispatch, useSelector } from 'src/store/store';
import config from 'config/config';
import i18n from 'src/utils/translate';
import { unenrollUser } from 'src/modules/programs/actions';
import { titleLarge, titleMedium, textLight, textLinkSecondary } from 'styles-js/mixins/typography';
import { LinkButton } from 'styles-js/buttons';
import EnrollButton from 'src/modules/programs/components/enrollButton';
import Icon from 'src/components/icon';

export default function Header() {
  const dispatch = useDispatch();
  const { isEnrolled, details = {}, progress } = useSelector(({ pages }) => pages.programs);
  const { code: slug, name: programName, totalEnrolledCount } = details;
  const [isHovered, setIsHovered] = useState(false);

  const onButtonClick = async () => {
    await dispatch(unenrollUser());
    setIsHovered(false);
  };

  return (
    <Wrapper>
      <Banner style={{ backgroundImage: `url(${config.cdn.programs}${slug}/landing-page-banner.jpg)` }}/>
      <ContentWrapper>
        <InnerWrapper>
          <Title>{programName}</Title>
          <div>
            {totalEnrolledCount > 50 && <GreySpan>{totalEnrolledCount} {i18n.t('enrolled')}</GreySpan>}

            {totalEnrolledCount > 50 && isEnrolled && <Separator> • </Separator>}

            {isEnrolled && (
              progress === 100
                ? <GreySpan><Icon colour="colorGreen" icon="ok" /> {i18n.t('Completed')}</GreySpan>
                : (
                  <StatusButton
                    type="button"
                    onClick={onButtonClick}
                    onMouseEnter={() => setIsHovered(true)}
                    onMouseLeave={() => setIsHovered(false)}
                  >
                    { isHovered
                      ? <><Icon colour="colorGreen" icon="close" /> {i18n.t('Leave program?')}</>
                      : <><Icon colour="colorGreen" icon="ok" /> {i18n.t('Enrolled')}</>
                    }
                  </StatusButton>
                )
            )}
          </div>
        </InnerWrapper>
        <EnrollButtonContainer>
          <EnrollButton />
        </EnrollButtonContainer>
      </ContentWrapper>
    </Wrapper>
  );
}

const Wrapper = styled.div`
  border-bottom: 1px solid ${props => props.theme.colorGreyLight};
`;

const Banner = styled.div`
  background-size: cover;
  background-position: 50%;
  padding-top: 20%;

  @media (${props => props.theme.underScreenSmall}) {
    padding-top: 30%;
  }

  @media (min-width: 1900px) {
    padding-top: 0;
    height: 380px;
  }
`;

const ContentWrapper = styled.div`
  max-width: 1200px;
  min-height: 84px;
  margin: auto;
  padding: 10px 20px;
  overflow: hidden;

  @media (${props => props.theme.underScreenSmall}) {
    min-height: 72px;
  }

  @media (${props => props.theme.underScreenXxsmall}) {
    padding: 10px 15px;
  }
`;

const InnerWrapper = styled.div`
  float: left;

  @media (${props => props.theme.underScreenMedium}) {
    float: none;
  }
`;

const Title = styled.h1`
  ${titleLarge};
  margin-bottom: 5px;

  @media (${props => props.theme.underScreenSmall}) {
    ${titleMedium};
  }
`;

const GreySpan = styled.span`
  ${textLight};
`;

const Separator = styled.span`
  color: ${props => props.theme.colorGreyLight};
  margin: 0 4px;
`;

const StatusButton = styled(LinkButton)`
  ${textLinkSecondary};
`;

const EnrollButtonContainer = styled.div`
  float: right;

  @media (${props => props.theme.underScreenMedium}) {
    float: none;
    margin-top: 10px;
  }
`;
